import request from "../utils/request";

// 手机号验证码登录
export async function fetchAccountLogin(params: any) {
    return request.post("/login/checkLogin", {
        data: params,
    });
}


// 登录
export async function fetchAccountLogOut(params: any) {
    return request.post("/login/logOut", {
        data: params,
    });
}
// 发送验证码
export async function fetchSendCode(params: any) {
    return request.post("/login/sendSms", {
        data: params,
    });
}
